
export function _moneyFormat(value, digits = 2) {
    return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: digits})
        .format(value)
}
